<template>
  <span v-if="fromNow">
    <span v-tippy>{{parsedFromNow}}</span>
    <tippy>{{parsedDate}}</tippy>
  </span>
  <span v-else>
    {{parsedDate}}
  </span>
</template>


<script>

import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';

dayjs.extend(relativeTime);


export default {
  name: 'dateTime',
  props: ['date', 'fromNow'],
  created: function () {
    if (this.timeDelta < this.maxDeltaForLiveUpdate) {
      this.deltaInterval = setInterval(() => {
        this.intervalCounter++;
        if(this.intervalCounter >= this.maxLiveUpdateTicks) {
          clearInterval(this.deltaInterval);
        }
      }, this.updateCheckInterval);
    }
  },
  beforeUnmount() {
    if(this.deltaInterval) {
      clearInterval(this.deltaInterval);
    }
  },
  computed: {
    parsedDate() {
      return dayjs(this.date).format('DD/MM/YYYY HH:mm');
    },
    parsedFromNow() {
      if (this.intervalCounter >= 0) {
        if (dayjs(this.date) >= dayjs()) {
          return this.$t('conversation.justNow');
        } else {
          return dayjs(this.date).fromNow();
        }
      }
      return '';
    },
    timeDelta() {
      return dayjs().diff(this.date, 'minute');
    }
  },
  watch: {
    date(newDate, oldDate) {
      if (newDate && oldDate) {
        this.intervalCounter = 0;
        if (this.timeDelta < this.maxDeltaForLiveUpdate) {
          this.deltaInterval = setInterval(() => {
            this.intervalCounter++;
            if(this.intervalCounter >= this.maxLiveUpdateTicks) {
              clearInterval(this.deltaInterval);
            }
          }, this.updateCheckInterval);
        }
      }
    }
  },
  data() {
    return {
      deltaInterval: undefined,
      intervalCounter: 0,
      maxDeltaForLiveUpdate: 50,
      maxLiveUpdateTicks: 100,
      updateCheckInterval: 5000,
    }
  },
}
</script>
